import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Dashboard from './components/Dashboard'
import Overview from './components/Overview'
import Traffic from './components/Traffic'
import Conversions from './components/Conversions'
import Realtime from './components/Realtime'

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/traffic" element={<Traffic />} />
          <Route path="/conversions" element={<Conversions />} />
          <Route path="/realtime" element={<Realtime />} />
        </Routes>
      </Layout>
    </div>
  )
}

export default App 